import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { SurveysCoursesReportRow, reportsApi } from "api/reportsApi";
import { PaziaDateSelect, Stars } from "components/atoms";
import { TanTableClient, useFilters, TanTableColumn } from "components/molecules";
import { FormFiltersBackground, PageMain } from "components/molecules";
import { PaziaBreadcrumbs } from "components/atoms";
import { routes } from "consts";
import { useNavigate } from "react-router-dom";
import { REPORTS_IDS, REPORTS_NAMES } from "consts/reports";

export const SurveysCourses = () => {
  const navigate = useNavigate();
  const { filter, changeFilter } = useFilters();
  const { data, isLoading, refetch } = useQuery({
    queryKey: QUERIES_KEYS.REPORTS.SURVEYS_COURSES(),
    queryFn: () => reportsApi.getSurveysCoursesReport(filter),
  });

  useEffect(() => {
    refetch();
  }, [filter]);
  const columns: TanTableColumn<SurveysCoursesReportRow>[] = [
    {
      id: "courseName",
      accessorKey: "courseName",
      header: "Kurs",
      size: 500,
      cell: (info) => (
        <span
          onClick={(e) => {
            e.stopPropagation();
            navigate(routes.COURSES_MANAGE_NESTED.FINANCES(info.row.original.courseId));
          }}
          className="cursor-pointer hover:underline"
        >
          {info.getValue<string>()}
        </span>
      ),
    },
    {
      id: "numberOfSurveys",
      accessorKey: "numberOfSurveys",
      header: "Ilość głosów",
    },
    {
      id: "averageRating",
      accessorKey: "averageRating",
      header: "Średnia ocena",
      cell: (info) => {
        const rating = info.getValue<number>();
        return (
          <div className="flex items-center gap-2">
            <span className="font-semibold"> {rating} / 5</span>
            <Stars numberOfStars={rating} />
          </div>
        );
      },
    },
  ];

  const onFromDateChange = (date: Date | null) =>
    changeFilter("from", date ? `createdDate ge ${date.toISOString()}` : "");

  const onToDateChange = (date: Date | null) => changeFilter("to", date ? `createdDate le ${date.toISOString()}` : "");

  const tableData = data?.data ?? [];
  return (
    <PageMain>
      <PaziaBreadcrumbs
        segments={[{ title: "Raporty", path: routes.REPORTS }, { title: REPORTS_NAMES[REPORTS_IDS.SURVEYS_COURSES] }]}
      />
      <FormFiltersBackground>
        <div className="flex flex-wrap items-center gap-2">
          <PaziaDateSelect name="dateFrom" label="Data od" onChange={onFromDateChange} />
          <PaziaDateSelect name="dateTo" label="Data od" onChange={onToDateChange} />
        </div>
      </FormFiltersBackground>
      <div>
        <TanTableClient data={tableData} columns={columns} />
      </div>
    </PageMain>
  );
};
